/* Gallery filters + lightbox, ported from Gallery.dc.html (2026-08-10 handoff).
   The WALL OF SHAME tab (screen 5d of the W.I.G. handoff, 2026-09-03) swaps the
   photo columns for the wall in place and reads the public wig_wall view. */
(function () {
  var filters = document.querySelector('[data-mpg-filters]');
  if (!filters) return;

  var tiles = Array.prototype.slice.call(document.querySelectorAll('.mpg-tile'));
  var cols = document.querySelector('.mpg-cols');
  var close = document.querySelector('.mpg-close');
  var lightbox = document.querySelector('[data-mpg-lightbox]');
  var lightboxImg = document.querySelector('[data-mpg-lightbox-img]');
  var wall = document.querySelector('[data-mpg-wall]');

  function pick(cat) {
    filters.querySelectorAll('.mpg-filter').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-mpg-filter') === cat);
    });
    var onWall = cat === 'WALL';
    if (cols) cols.hidden = onWall;
    if (close) close.hidden = onWall;
    if (wall) { wall.hidden = !onWall; if (onWall) loadWall(); }
    tiles.forEach(function (t) {
      t.hidden = !onWall && cat !== 'ALL' && t.getAttribute('data-mpg-cat') !== cat;
    });
    try { history.replaceState(null, '', onWall ? '#wall' : location.pathname); } catch (e) {}
  }
  filters.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mpg-filter]');
    if (btn) pick(btn.getAttribute('data-mpg-filter'));
  });

  /* ---------- the Wall of Shame ---------- */
  var cfg = window.MPX_WIG || {};
  var entries = null, showPaid = false;
  var grid = document.querySelector('[data-mpg-wall-grid]');
  var countEl = document.querySelector('[data-mpg-wall-count]');
  var paidBtn = document.querySelector('[data-mpg-wall-paid]');

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function pic(e) {
    if (!e.image_path) return '<div class="mpg-wos__sil" aria-label="Silhouette. The photo was taken down; the entry stays."></div>';
    return '<img src="' + cfg.url + '/storage/v1/object/public/wig-public/' + esc(e.image_path) + '" alt="' + esc(e.first_name) + ', mugshot" loading="lazy" width="400" height="500">';
  }
  function days(e) {
    var n = Number(e.days_overdue) || 0;
    if (e.status === 'redeemed') return 'PAID, ' + n + ' DAY' + (n === 1 ? '' : 'S') + ' LATE';
    return n + ' DAY' + (n === 1 ? '' : 'S');
  }
  function card(e) {
    var red = e.status === 'redeemed';
    return '<div class="mpg-wos__card' + (red ? ' mpg-wos__card--redeemed' : '') + '">' +
      '<div class="mpg-wos__shot">' + pic(e) + '<span class="mpg-wos__stamp' + (red ? ' mpg-wos__stamp--mint' : '') + '">' + (red ? 'REDEEMED' : 'FLAKED') + '</span></div>' +
      '<div class="mpg-wos__name">' + esc(e.first_name) + '</div>' +
      '<div class="mpg-wos__days">' + days(e) + '</div>' +
      '<div class="mpg-wos__dare">Owed: ' + esc(e.dare) + (red ? ' Did it. Late. Respect, eventually.' : ' ' + esc(e.title) + ', unpaid.') + '</div>' +
    '</div>';
  }
  function paint() {
    if (!grid || !entries) return;
    var list = entries.filter(function (e) { return showPaid ? e.status === 'redeemed' : e.status === 'flaked'; });
    if (!list.length) {
      grid.innerHTML = '<div class="mpg-wos__empty">' + (showPaid ? 'Nobody has paid up late yet. The flakes are still flaking.' : 'Nobody has flaked yet. Give it a weekend.') + '</div>';
    } else grid.innerHTML = list.map(card).join('');
    if (paidBtn) paidBtn.textContent = showPaid ? '← Back to the flakes' : 'See who actually paid up →';
  }
  function loadWall() {
    if (entries || !cfg.url) return;
    fetch(cfg.url + '/rest/v1/wig_wall?select=id,first_name,dare,title,status,days_overdue,image_path,takedown,flaked_at&order=flaked_at.desc.nullslast', {
      headers: { apikey: cfg.anon, authorization: 'Bearer ' + cfg.anon }
    }).then(function (r) { return r.ok ? r.json() : []; }).then(function (rows) {
      entries = rows || []; paint();
      var flaked = entries.filter(function (e) { return e.status === 'flaked'; }).length;
      if (countEl) { countEl.textContent = String(flaked); countEl.hidden = !flaked; }
    }).catch(function () {
      entries = []; if (grid) grid.innerHTML = '<div class="mpg-wos__empty">The wall is down. The flakes are still flakes.</div>';
    });
  }
  if (paidBtn) paidBtn.addEventListener('click', function () { showPaid = !showPaid; paint(); });

  /* the badge count shows before the tab is ever opened, so the tab earns the click */
  if (cfg.url && countEl) {
    fetch(cfg.url + '/rest/v1/wig_wall?select=id&status=eq.flaked', { headers: { apikey: cfg.anon, authorization: 'Bearer ' + cfg.anon, prefer: 'count=exact', 'range-unit': 'items', range: '0-0' } })
      .then(function (r) { var c = (r.headers.get('content-range') || '').split('/')[1]; var n = Number(c) || 0; countEl.textContent = String(n); countEl.hidden = !n; }).catch(function () {});
  }
  if (location.hash === '#wall') pick('WALL');

  /* the two hero videos weigh 1.5MB together: they load and play only in view,
     only after the page has loaded and the browser is idle (the top one sits in
     the first screen, so without the wait it competes with the photos for the
     first paint), and never on Save-Data or a 2g/3g connection, where the
     poster is the whole show */
  var vids = document.querySelectorAll('[data-mpg-video]');
  var conn = navigator.connection || {};
  var slowData = !!conn.saveData || /(^|-)2g$|^3g$/.test(conn.effectiveType || '');
  if (vids.length && !slowData && 'IntersectionObserver' in window) {
    var watchVids = function () {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; v.play().catch(function () {}); }
          else v.pause();
        });
      }, { threshold: 0.35 });
      vids.forEach(function (v) { vio.observe(v); });
    };
    var whenIdle = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(watchVids, { timeout: 4000 });
      else setTimeout(watchVids, 1500);
    };
    if (document.readyState === 'complete') whenIdle();
    else window.addEventListener('load', whenIdle, { once: true });
  }

  /* ---------- lightbox ---------- */
  function openLightbox(src) {
    lightboxImg.style.backgroundImage = 'url("' + src + '")';
    lightbox.hidden = false;
  }
  function closeLightbox() {
    lightbox.hidden = true;
    lightboxImg.style.backgroundImage = 'none';
  }
  tiles.forEach(function (t) {
    t.addEventListener('click', function () {
      var full = t.getAttribute('data-mpg-full') || (t.querySelector('img') || {}).src;
      if (full) openLightbox(full);
    });
  });
  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.closest('[data-mpg-lightbox-close]')) closeLightbox();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lightbox.hidden) closeLightbox(); });
  }
})();
